<div class="viewer-container">
    <div #container class="canvas-container" style="width: 100%; position: relative;"></div>

    <section class="viewer-information-container">
        <div class="omit-from-screenshot metrics-displayer" style="height: 30px; top: -20px;">
        @if(xText && yText && valueText){
            <table class="styled-table">
                <tr>
                    <td>{{xLabel()}}</td>
                    <td>:</td>
                    <td>{{xText}}</td>
                </tr>
                <tr>
                    <td>{{yLabel()}}</td>
                    <td>:</td>
                    <td>{{yText}}</td>
                </tr>
                <tr>
                    <td>Value</td>
                    <td>:</td>
                    <td>{{valueText}}</td>
                </tr>
                @if(focusedShot(); as shot){
                <tr>
                    <td>Shot ID</td>
                    <td>:</td>
                    <td>{{shot['shot_id']}}</td>
                </tr>
                <tr>
                    <td>{{viewerSettings.selectedShotOverlayMetric()}}</td>
                    <td>:</td>
                    <td>{{shot[viewerSettings.selectedShotOverlayMetric()] | number: '1.2-2'}}</td>
                </tr>
                }
            </table>
        }
        </div>

        <div class="legends-section">
            @if(isDepth() && viewerSettings.showShotOverlay()){
            <div class="shot-color-bar">
                <span class="shot-color-min">{{viewerSettings.shotColorMin() | number: '1.0'}}</span>
                <span class="shot-color-max">{{viewerSettings.shotColorMax() | number: '1.0'}}</span>
                <span class="shot-color-type">{{viewerSettings.selectedShotOverlayMetric()}}</span>
            </div>
            }
            @if(this.colorbar()){
            <div class="legend-container">
                <div [style.backgroundImage]="'url('+this.colorbar()+')'" class="legend-colorbar"></div>
                <span class="legend-min">{{limits()?.min | significantFigures: 4}}</span>
                <span class="legend-max">{{limits()?.max | significantFigures: 4}}</span>
                <span class="legend-type">{{jobState.selectedModel()}}</span>
            </div>
            }
        </div>
    </section>
</div>